import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=28770e80&scoped=true&lang=pug&"
import script from "./CoursesList.vue?vue&type=script&lang=js&"
export * from "./CoursesList.vue?vue&type=script&lang=js&"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=28770e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28770e80",
  null
  
)

export default component.exports